// extracted by mini-css-extract-plugin
module.exports = {"main":"main__-TZcq","player":"player__39OLU"};